import Debug from 'utils/debug';
import 'utils/debug/Error';
import 'utils/debug/Outer';

export default { install: Debug.init.bind(Debug) };
